import Vue from 'vue'
import Vuex from 'vuex'
import { bookApi } from '../service/getData'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    book:{},
    redirecturl:"https://www.xinsiketang.com",
    textBookData:{},
    showNaotu:false,
    bookId:"",
    userId:"", 
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
